import { render, staticRenderFns } from "./salesAll.vue?vue&type=template&id=fb5b16d8&scoped=true&"
import script from "./salesAll.vue?vue&type=script&lang=js&"
export * from "./salesAll.vue?vue&type=script&lang=js&"
import style0 from "./salesAll.vue?vue&type=style&index=0&id=fb5b16d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5b16d8",
  null
  
)

export default component.exports